import { Demand } from "../../../../assets/svg-icons";

export const OM = {
    name: "Order Management",
    route: null,
    permissions: [],
    icon: Demand,
    shortName: "Order",
    child: {
        "Sales Order": {
            name: "Sales Order",
            route: "/ieo/sales-order",
            permissions: ["XYZ_VIEW"],
        },
    },
};
